package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components


import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.BillSearchTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.extractTime
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.HeaderTitle
import org.hs_soft.runmynesto.pages.components.CustomTable

@Composable
fun BillSearchTable(
    windowSizeMode: WindowSizeModeEnum,
    showRefreshIcon: Boolean,
    statisticData: List<BillSearchStatisticDataItem>?,
    onItemClick: (BillSearchStatisticDataItem) -> Unit,
    selectedBillSearchItem: BillSearchStatisticDataItem?,
) {
    key(statisticData) {
        val (columns, tableData, footerData) = setBillSearchTableInfo(
            statisticData = statisticData,
        )

        CustomTable(
            columns = columns,
            data = tableData,
            height = Dimen.billSearchTableHeight,
            showRefreshButton = showRefreshIcon,
            width = if (windowSizeMode != WindowSizeModeEnum.Desktop)
                Dimen.billSearchPhoneTabletWidth
            else null,
            footerType = FooterType.ALIGNED,
            footerData = footerData,
            selectedId = selectedBillSearchItem?.id,
            onRowClick = {id,_->
                statisticData?.find { it.id == id }?.let { item ->
                    onItemClick(item)
                }
            },
        )
    }
}


@Composable
private fun setBillSearchTableInfo(
    statisticData: List<BillSearchStatisticDataItem>?,
): Triple<List<TableColumn>, List<Map<String, Any?>>?, Map<String, String>> {

    val columns = BillSearchTableHeadersEnum.entries.map { header ->
        TableColumn(
            header = header.getTitle(),
            key = header.key,
            isNumeric = header.isNumeric,
            sortFunction = when {
                header.isNumeric -> { row ->
                    (row[header.key]?.toString() ?: "0")
                        .replace(",", "").toDoubleOrNull() ?: 0.0
                }
                header == BillSearchTableHeadersEnum.DATE -> { row ->
                    val dateStr = row[header.key]?.toString() ?: ""
                    dateStr
                }
                header == BillSearchTableHeadersEnum.TIME -> { row ->
                    val timeStr = row[header.key]?.toString() ?: ""
                    timeStr.replace(":", "")
                }
                else -> null
            },
            customContent = if (header == BillSearchTableHeadersEnum.CANCELLATION) {
                { row ->
                    {
                        val isCancelled = row["isCancelled"] as? Boolean ?: false
                        if (isCancelled) {
                            CustomIcon(
                                icon = Res.PathIcon.verify,
                                iconColor = Theme.ActionActive.hex,
                                onIconClick = {}
                            )
                        }
                    }
                }
            } else null
        )
    }

    val tableData = statisticData?.map { item ->
        mapOf(
            "id" to (item.id ?: ""),
            "rawNumber" to (item.number ?: ""),
            "rawDateTime" to (item.dateTime ?: ""),
            "cashRegisterId" to (item.cashRegisterId ?: ""),
            "isCancelled" to (item.isCancelled ?: false),
            BillSearchTableHeadersEnum.DATE.key to extractDate(item.dateTime ?: ""),
            BillSearchTableHeadersEnum.TIME.key to extractTime(item.dateTime ?: ""),
            BillSearchTableHeadersEnum.TABLE_NUMBER.key to item.tableNumber,
            BillSearchTableHeadersEnum.DEVICES.key to item.cashRegisterName,
            BillSearchTableHeadersEnum.NUMBER.key to (item.number ?: ""),
            BillSearchTableHeadersEnum.USER_NAME.key to item.userName,
            BillSearchTableHeadersEnum.CANCELLATION.key to "",
            BillSearchTableHeadersEnum.TOTAL.key to formatToTwoDecimals(item.total)
        )
    }

    val totalSum = statisticData?.sumOf { it.total ?: 0.0 } ?: 0.0

    val footerData = mapOf(
        BillSearchTableHeadersEnum.DATE.key to "",
        BillSearchTableHeadersEnum.TIME.key to "",
        BillSearchTableHeadersEnum.NUMBER.key to "",
        BillSearchTableHeadersEnum.TABLE_NUMBER.key to "",
        BillSearchTableHeadersEnum.DEVICES.key to "",
        BillSearchTableHeadersEnum.USER_NAME.key to "",
        BillSearchTableHeadersEnum.CANCELLATION.key to "",
        BillSearchTableHeadersEnum.TOTAL.key to formatToTwoDecimals(totalSum, false)
    )

    return Triple(columns, tableData, footerData)
}

